import { Suspense, lazy } from 'react';

import { KDErrorBoundary } from '@/components';
import { KDLayoutDashboardLoader } from '@/layouts/dashboard';

const HomePage = lazy(() => import('./Home.page'));

export const Home = () => {
  return (
    <KDErrorBoundary>
      <Suspense fallback={<KDLayoutDashboardLoader />}>
        <HomePage />
      </Suspense>
    </KDErrorBoundary>
  );
};
